import { createExportContext } from './createExportContext';

import type {
  ExportNameContextType,
  ExportMetaContextType,
  ExportPreviewContextType,
  ExportRequestContextType,
  ExportSettingsContextType
} from '../types/context.types';

export const { useStrictContext: useExportSettings, Provider: ExportSettingsProvider } =
  createExportContext<ExportSettingsContextType>('ExportSettings');

export const { useStrictContext: useExportPreview, Provider: ExportPreviewProvider } =
  createExportContext<ExportPreviewContextType>('ExportPreview');

export const { useStrictContext: useExportRequest, Provider: ExportRequestProvider } =
  createExportContext<ExportRequestContextType>('ExportRequest');

export const { useStrictContext: useExportMeta, Provider: ExportMetaProvider } =
  createExportContext<ExportMetaContextType>('ExportMeta');

export const { useStrictContext: useExportNameMeta, Provider: ExportNameProvider } =
  createExportContext<ExportNameContextType>('ExportName');
